export default "__VITE_ASSET__4eVYyj3X__"